import { Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { IonicModule } from '@ionic/angular';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';

import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { LanguageLoader } from '@shared/helpers/language-loader';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';

export const imports = [
    BrowserModule,
    IonicModule.forRoot({
        mode: 'md'
    }),
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production, registrationStrategy: 'registerImmediately' }),
    HttpClientModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [HttpClient, Injector]
        }
    }),
    NgxPermissionsModule.forRoot(),
    NgxQRCodeModule,
];

function createTranslateLoader(http: HttpClient, injector: Injector) {
    // return new TranslateHttpLoader(http, './assets/i18n/', '.json');
    // return new TranslateHttpLoader(http, `${environment.baseUrl}i18n/`, '.json');
    return new LanguageLoader(http, injector, `${environment.baseUrl}i18n/`, '.json');
}